/// <reference path="../../../WebUI/typings/tsd.d.ts" />
import * as React from "react";
import * as ReactDOM from "react-dom";
import {ProgressRingControl} from "../../../Intercom.ReactUI/Views/ProgressRingControl";

export interface ProgressPanelProps {
    message: string;
}

export interface ProgressPanelState {
}

export class ProgressPanel extends React.Component<ProgressPanelProps, ProgressPanelState> {
    constructor(props) {
        super(props);
    }

    public render(): JSX.Element {
        return (
            <div className="progress-panel">
                <ProgressRingControl/>
                <div className="progress-message" aria-live="polite">{this.props.message}</div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./Client/Views/ProgressPanel.tsx